






























































































































import Modal from 'ant-design-vue/lib/modal'
import moment from 'moment'
import { Component, Prop } from 'vue-property-decorator'

import { SelectOption } from '../../../../../logic/types'
import { Subscription } from '../../../../../shared/types/BotUsers'
import { ChannelLimitedTypeEnum } from '../../../../../shared/types/Channel'
import { atSignedLogin } from '../../../../../shared/utils/tgLoginHelpers'
import { UserProfile } from '../../../../BotUsers/components/Users/types'
import ChannelSubscriptionInfo from '../../../../ChannelSubscriptionInfo/ChannelSubscriptionInfo.vue'
import { StepUnit } from '../../../../PeriodSimplifier/types'
import { UseFields } from '../../../../Pi'
import { SubscriptionsHelper } from '../../../types'
import SubscriptionEditor from '../components/Subscriptions/SubscriptionEditor.vue'

@Component({
  data() {
    return {
      ChannelLimitedTypeEnum,
      moment,
      StepUnit,
      atSignedLogin
    }
  },
  components: {
    ChannelSubscriptionInfo,
    SubscriptionEditor,
  }
})
export default class ProfileSubscriptions extends UseFields {
  @Prop() profile!: UserProfile

  @Prop() helper!: SubscriptionsHelper

  @Prop() removeSubscription!: (user_id: number, channel_id: number) => Promise<void>

  @Prop() createSubscription!: (user_id: number, channel_id: number, duration: number) => Promise<Subscription>

  @Prop() getChannelTitle!: (id: number) => string | undefined

  @Prop() getFreeChannelsOptions!: (busy: Array<number>) => Array<SelectOption>

  isOpen = false

  currentSubscription: any = null

  get freeChannels(): Array<{ label: string, value: number }> {
    return this.getFreeChannelsOptions(this.busyChannels)
  }

  get busyChannels(): Array<number> {
    if (this.profile.subscriptions) {
      return this.profile.subscriptions.map((sub) => sub.channel.id)
    }

    return []
  }

  setNewSubscription(): void {
    this.currentSubscription = {
      channel: null,
      time: 30,
      action: 'add',
    }
  }

  setCurrentSubscription(subscription: Subscription): void {
    this.currentSubscription = {
      channel: subscription.channel.id,
      time: 30,
      action: 'edit',
      expire: subscription.expire,
    }
  }

  removeSubscriptionHandler(id: number): void {
    Modal.confirm({
      okText: this.$t('yes_button').toString(),
      okType: 'danger',
      cancelText: this.$t('cancel_button').toString(),
      centered: true,
      content: this.$t('user_profile_remove_subscription_modal_alert').toString(),
      onOk: () => {
        this.removeSubscription(this.profile.user_id, id)
          .then(() => {
            if (this.profile.subscriptions) {
              const index = this.profile.subscriptions.findIndex((sub) => sub.channel.id === id)

              if (index !== -1) {
                this.profile.subscriptions.splice(index, 1)
              }
            }
          })
      }
    })
  }

  setEditableSubscription(subscription: Subscription): void {
    if (this.profile.subscriptions) {
      const index = this.profile.subscriptions.findIndex((sub) => sub.channel.id === subscription.channel.id)

      if (index !== -1) {
        this.profile.subscriptions.splice(index, 1, subscription)
      } else {
        this.profile.subscriptions.push(subscription)
      }
    }
  }

  get subscriptions(): Array<Subscription> {
    return this.profile.subscriptions ?? []
  }
}
